import styled from "styled-components";
import {
  BREAKPOINTS,
  COLORS,
  TYPOGRAPHY
} from "../../containers/impact-report/constants";

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
  padding: 24px;

  @media (min-width: ${BREAKPOINTS.MD}) {
    justify-content: center;
    gap: 8px;
  }
`;

export const PaginationButton = styled.button`
  display: flex;
  align-items: center;
  background-color: transparent;
  border: none;
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  ${TYPOGRAPHY.BODY_NORMAL_MEDIUM}
  color: ${props => (props.disabled ? COLORS.DISABLED : COLORS.NEUTRAL_500)};
  padding: 0;

  &:hover:not(:disabled) {
    color: ${COLORS.LINK_BLUE};
  }
`;

export const PaginationText = styled.div`
  ${TYPOGRAPHY.BODY_LARGE_MEDIUM}
  color: ${COLORS.NEUTRAL_500};
  flex: 1;
  text-align: center;

  @media (min-width: ${BREAKPOINTS.MD}) {
    display: none;
  }
`;

export const PageNumbersContainer = styled.div`
  display: none;

  @media (min-width: ${BREAKPOINTS.MD}) {
    display: flex;
    gap: 8px;
  }
`;

export const PageNumberButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: ${props =>
    props.isActive ? COLORS.LINK_BLUE_HOVER : COLORS.WHITE};
  border-width: ${props => (props.isActive ? "2px" : "1px")};
  border-style: solid;
  border-color: ${props =>
    props.isActive ? COLORS.LINK_BLUE : COLORS.BORDER_COLOR};
  border-radius: 4px;
  cursor: pointer;
  ${TYPOGRAPHY.BODY_NORMAL_MEDIUM}
  color: ${COLORS.NEUTRAL_500};

  &:hover {
    border-width: 2px;
    border-color: ${COLORS.LINK_BLUE};
  }

  &:active {
    border-width: 2px;
    background-color: ${COLORS.LINK_BLUE_HOVER};
  }
`;

export const ButtonText = styled.span`
  ${TYPOGRAPHY.BODY_LARGE_MEDIUM}
`;
